export default __webpack_public_path__ + "static/media/logo.d3d98024.svg";